import {
  DurationSeries,
  DurationSeriesImpl,
} from "firefly-shared-ts-timeseries";
import { useMemo } from "react";
import { BurnTemperatureSeriesNonSensitive } from "../../BurnTemperatureSeriesNonSensitive";
import { FlueId } from "../../../chimney/flue/FlueId";
import { MuiDurationSeriesOptions } from "firefly-shared-ts-durationseries-mui-chart";

export const useDurationSeries = (
  burnTimeSeries: BurnTemperatureSeriesNonSensitive[] | undefined,
  burnColors: Array<string | undefined> | undefined,
  burnDisplayNames: Array<string> | undefined,
  flueId: FlueId,
  unit: string
): {
  durationSeries: Array<DurationSeries<number | null>> | undefined;
  durationSeriesOptions?: Array<MuiDurationSeriesOptions>;
} => {
  return useMemo(() => {
    const durationSeries = burnTimeSeries?.map((burnSeries, index) => {
      const displayName = burnDisplayNames?.[index];
      return new DurationSeriesImpl({
        info: {
          id: `${burnSeries.burnId}`,
          sid: flueId,
          name: "",
          displayName: displayName,
          resolution: "",
          unit: unit,
        },
        points: burnSeries.dataPoints,
      });
    });
    const durationSeriesOptions = burnTimeSeries?.map((burnSeries, index) => {
      return {
        color: burnColors?.[index] ?? undefined,
      } as MuiDurationSeriesOptions;
    });
    if (durationSeriesOptions !== undefined) {
      return { durationSeries, durationSeriesOptions };
    }
    if (durationSeries === undefined) return { durationSeries };
    return { durationSeries };
  }, [burnTimeSeries, burnDisplayNames, flueId, unit, burnColors]);
};
